import { CONNECTED_SERVICE_VALUES, type ConnectedService } from '@dawn/feature-config/widgets';
import { create } from 'zustand';

/**
 * The services the tenant connected at onboarding (`GET /connected-services`),
 * which the widget service filter offers. Every service until the answer
 * arrives, or when the request fails: what the filter offered before.
 * `settled` is the answer or the failure having arrived.
 */
export const useConnectedServicesStore = create<{
  services: readonly ConnectedService[];
  settled: boolean;
}>()(() => ({ services: CONNECTED_SERVICE_VALUES, settled: false }));
